<template lang="pug">
BriqPanel(data-test-id="prefill")
  h2 Link to an external {{ feedType }}
  p.bold Get all settings from an external {{ feedType }}
  p.bold Find external {{ feedType }}
  p Type in the name of the external {{ feedType }} and the data will be prefilled.

  .external-item.mb-XS(v-for="(item, key) in selectedExternalItems" :key="key")
    .external-item-display(
      data-test-id="external-item-display"
      :class="{ 'deleted-external-product': item.deleted }"
      ) {{ display(item) }}
    button.decouple.bg-grey-900.text-white.hover_bg-grey-800(
      @click="decouple(item)"
      data-test-id="decouple"
      )
      BriqIcon(name="icon-input-trash-icon")

  .feed-search(v-if="isSelectingExternalItem" data-test-id="feed-search")
    span.search-icon
      BriqIcon(name="icon-search-icon")
    vue-autosuggest(
      v-model="suggestionValue"
      :suggestions="filteredOptions"
      :input-props="inputProps"
      :get-suggestion-value="s => display(s.item)"
      @selected="onSelected"
      )
      template(slot-scope="{suggestion}")
        .suggestion.standard-border(v-html="formatExternalItem(suggestion.item, suggestionValue)")

  button.add-suggestion.bg-grey-900.text-white.hover_bg-grey-800(
    v-show="showAddExternalItemButton"
    @click="isSelectingExternalItem = true"
    data-test-id="add-external-item"
    )
    BriqIcon(name="icon-input-plus-icon") 
    span {{ feedType }}
  .validation-message.mt-10(v-if="error" data-test-id="prefill-error") {{ error }}
</template>

<script>
// @focus="onFocus"
import { VueAutosuggest } from 'vue-autosuggest'
import { filter, pipe, toLower, includes, map, find, isEmpty } from 'ramda'

export default {
  components: { VueAutosuggest },
  props: {
    feedType: {
      type: String,
      validator: val => val === 'product' || val === 'resource',
      required: true,
    },
    options: Array,
    selectedExternalIds: Array,
    canAddMultipleExternalItems: Boolean,
    display: { type: Function, default: a => a }, // function used to format selected external items
    formatExternalItem: { type: Function, default: a => a }, // function used to format suggestions matched with query
    disabled: Boolean,
    error: String,
  },
  data() {
    return {
      suggestionValue: '',
      suggestions: [{ data: this.options }],
      isSelectingExternalItem: false,
    }
  },
  computed: {
    selectedExternalItems() {
      return this.selectedExternalIds
        ? map(
            selectedExternalId =>
              find(option => option.ExternalId === selectedExternalId)(this.options) || {
                ExternalId: selectedExternalId,
                NameInternal: `Deleted external ${this.feedType}`,
                ResourceName: 'N/A',
                deleted: true,
              },
          )(this.selectedExternalIds)
        : []
    },
    filteredOptions() {
      if (!this.suggestionValue) return [{ data: this.availableOptions }]
      const filterBy = text => filter(pipe(this.display, toLower, includes(toLower(text))))
      const data = filterBy(this.suggestionValue)(this.availableOptions)
      return [{ data }]
    },
    showAddExternalItemButton() {
      return (
        this.canAddMultipleExternalItems &&
        !this.isSelectingExternalItem &&
        this.availableOptions.length > 0
      )
    },
    availableOptions() {
      if (!this.selectedExternalIds || this.selectedExternalIds.length === 0) return this.options
      return filter(x => !includes(x.ExternalId, this.selectedExternalIds))(this.options)
    },
    inputProps() {
      return {
        class: 'autosuggest-input standard-border',
        placeholder: `name ${this.feedType}`,
      }
    },
  },
  methods: {
    onSelected(suggestion) {
      this.$emit('selected', suggestion)
      this.suggestionValue = ''
      this.isSelectingExternalItem = false
    },
    decouple(item) {
      this.$emit('decouple', item.ExternalId)
    },
  },
}
</script>

<style lang="stylus">
placeholderGrey = rgba(121, 134, 150, .4)
inputGrey = #2C333A
suggestionGrey = #4E5A6A

.feed-search
  box-sizing border-box
  color placeholderGrey
  font-size 1rem
  position relative
  margin-bottom 15px

.search-icon, .edit-icon
  position absolute
  display flex
  top 50%
  transform translate(0, -50%)

.search-icon
  left 12px

.edit-icon
  right 0
  transform translate(-100%, -50%)
  cursor pointer

.autosuggest-input
  outline none
  border-radius 3px
  padding 6px 8px 6px 38px
  cursor text
  min-width 275px
  color inputGrey

.autosuggest__results-container
  width 100%
  position absolute
  z-index 1
  background white
  box-shadow 0 2px 4px 0 rgba(0,0,0,0.15)

.autosuggest__results
  overflow-y auto
  max-height 400px

  ul
    list-style none
    padding-left 0
    margin 0

.suggestion
  width 100%
  box-sizing border-box
  padding 12px
  border-top none
  color suggestionGrey
  border-collapse collapse
  cursor pointer

  &:hover
    background #F1F3F6

.decouple
  margin-left 10px
  border-radius 3px
  width 36px
  height 36px

.add-suggestion
  border-radius 3px
  padding: 0px 10px 0px 10px;
  height 36px

  span
    margin-left 5px

.external-item
  display flex

.external-item-display
  width 100%
  padding 6px 8px 6px 10px
  background #eee
  border 1px solid #ebebeb
  border-radius 3px

.deleted-external-product
  border: 1px solid #e93838 
  color: #e93838
</style>
